export default __webpack_public_path__ + "static/media/pop-up-response.b0fe88a5.png";